import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import logo from "../../images/logo/log112.png"; // same logo used elsewhere

import MobileMenu from "../MobileMenu/MobileMenu";

const Header = () => {
  const [mobailActive, setMobailState] = useState(false);
  const [isSticky, setSticky] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
    setMobailState(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent"
    >
  
      {/* ================= MAIN HEADER ================= */}
      <div
        className={`xb-header stricky ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between">

            {/* LOGO */}
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <div
                  className="logo-pill"
                  style={{
                    background: "rgba(255,255,255,0.9)",
                    padding: "10px 18px",
                  }}
                >
                  <img
                    src={logo}
                    alt="ARO Events"
                    style={{ height: "32px" }}
                  />
                </div>
              </Link>
            </div>

            {/* NAV */}
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/">
                      <span>Home</span>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      <span>About</span>
                    </Link>
                  </li>
                 
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span>Contact Us</span>
                    </Link>
                  </li>
                </ul>
              </nav>

              {/* MOBILE MENU */}
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${
                    mobailActive ? "active" : ""
                  }`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(false)}
                    ></div>

                    <div className="xb-logo-mobile xb-hide-xl">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img src={logo} alt="mobile logo" />
                      </Link>
                    </div>

                    <nav className="xb-header-nav">
                      <MobileMenu />
                    </nav>
                  </div>
                </div>
                <div className="xb-header-menu-backdrop"></div>
              </div>
            </div>

            {/* MOBILE TOGGLE */}
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>

         

          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
